import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function ES_mobile_view_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-6'>1. The Course starts with the theoretical basics of Embedded Sysrems.</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Basics of an embedded system, Types of an embedded system, Components of an embedded system.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-6'>2. Understand the ins and outs of microchips using Atmega328. </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Architecture of Atmega328, Features of Atmega328, Components of Atmega328, SPI / UART, 12C.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-6'>3. Learn how to work on Ardunio using Ardunio IDE.</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to Arduino IDE, Installation of Arduino IDE, Embedded tools (Programmer/Debugger), Circuit connections using Breadboard, Program overview on IDE, Data types, Program lifecycle / Program structure, Memory management.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-6'>4. Understand the architecture of Arduino and learn how to program them.</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          GPIO / EEPROM, ADC and PWM, SPI / 12C, UART, Serial Port and Serial plotter. 
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-6'>5. Learn programming using TinkerCAD.</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Introduction to Tinkercad, Programming using Tinkercad.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-6'>6. Get a brief introduction to Bare Metal Programming.</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Bare Metal programming with Arduino, Programming Arduino using Linux CLI, Optimization techniques, Boot loader. <br></br>
          Zigbee/Rfd, Bluetooth/Nfc, Wifi, Protocols-TCP, UDP, MQTT/MQTTS,HTTP/HTTPS.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-6'>7. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project Overview. 
          </Typography>
        </AccordionDetails>
      </Accordion>
      {/* <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-5'>8. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project Overview.
          </Typography>
        </AccordionDetails>
      </Accordion> */}
    </div>
  );
}
